import update from 'immutability-helper';
import moment from 'moment';
import { DateMaker, MapWithIndex } from '../../../lib/helpers';

export const renderMonthOptions = activeStatus => {
  const result = [];
  if (activeStatus === 'plan') {
    result.push({ value: -1, label: 'All Months' });
  }
  return result.concat(
    MapWithIndex(DateMaker.spelledOutMonths, (label, index) => ({
      label,
      className: 'month-option',
      value: index,
    })),
  );
};

export const renderYearOptions = () => {
  const date = new Date();
  const years = [];
  for (let year = 2014; year <= date.getFullYear(); year++) {
    years.push(year);
  }
  return years
    .reverse()
    .map(label => ({ label, className: 'year-option', value: label }));
};

// The filter is an absolute number like 1 for January, but we have buckets that
// are paired with years "January 2019", so this method will generate both
// entries and finds the first match.
// Also moment counts month numbers starting from zero so offset it by one.
const BUCKET_DATE_FORMAT = 'YYYY-MM';
export const findValidMonth = (monthInt, buckets) => {
  if (monthInt === null) {
    return null;
  }

  const date = moment().month(monthInt);
  const thisYear = date.format(BUCKET_DATE_FORMAT);
  const nextYear = date.add(1, 'year').format(BUCKET_DATE_FORMAT);

  if (buckets[thisYear] !== undefined) {
    return thisYear;
  }

  return nextYear;
};

export const filterByMonth = (monthToFilter, buckets) => {
  // Auto expand the selected month and collapsed the not selected ones for better UX.
  if (monthToFilter !== null) {
    const allMonths = monthToFilter === 'All Months' ? true : null;

    for (const [key] of Object.entries(buckets)) {
      const collapsed = allMonths ? false : key != monthToFilter;

      buckets = update(buckets, {
        [key]: { $merge: { collapsed: collapsed } },
      });
    }
  }

  return buckets;
};
